/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: '标题',
        type: 'module-name'
    },

    {
        key: 'property_data',
        name: '属性',
        type: 'custom',
        content: [{
                key: 'background_type',
                name: '背景颜色',
                type: 'page-background',
                'radio-list': [{
                        label: '无',
                        value: 0
                    },
                    {
                        label: '颜色',
                        value: 1
                    }
                ]
            },
            {
                key: 'h1',
                name: '主标题',
                type: 'text'
            },
            {
                key: 'h2',
                name: '副标题',
                type: 'text'
            },
            {
                key: 'h1_color',
                name: '主标题颜色',
                type: 'color'
            },
            {
                key: 'h2_color',
                name: '副标题颜色',
                type: 'color'
            },
            {
                key: 'padding',
                name: '装饰图间距',
                type: 'text'
            },

            {
                key: 'choose_photo_left',
                name: '装饰图片左',
                type: 'choose-photo'
            },
            {
                key: 'choose_photo_right',
                name: '装饰图片右',
                type: 'choose-photo'
            }
        ]
    }
];

export default config;